import * as React from "react";
import {cx} from "emotion";

import "./tracing-summary.scss";

import {cs}               from "@Common/react/chain-services";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const TracingSummary = ({statusCounts, totalRecords}) => cs(
    () => (
        <div className="tracing-summary-7sj">
            <div className="left">
                {(() => {
                    const card = ({label, qty, icon, iconClass}) => (
                        <div className="card" key={label}>
                            <div className="icon">
                                <img className={iconClass} src={icon}/>
                            </div>
                            <div className="right">
                                <div className="label">
                                    {label}
                                </div>
                                <div className="qty">
                                    {qty}
                                </div>
                            </div>
                        </div>
                    );
                    return <>
                        {card({
                            label: "TOTAL PIECES ORDERED",
                            qty: totalRecords,
                            icon: require("./summary-icons/cart-shopping-solid.svg"),
                            iconClass: "cart-icon"
                        })}
                        {card({
                            label: "QR CODES SCANNED",
                            qty: statusCounts?.qrScans ?? 0,
                            icon: require("./summary-icons/qrcode-solid.svg"),
                            iconClass: "qr-icon"
                        })}
                        {card({
                            label: "INFORMED DELIVERY CLICKS",
                            qty: statusCounts?.IDClicks ?? 0,
                            icon: require("./summary-icons/arrow-pointer-solid.svg"),
                            iconClass: "click-icon"
                        })}
                    </>;
                })()}
            </div>
            <table className="right">
                <thead>
                    <tr>
                        <th className="label">
                            STATUS
                        </th>
                        <th className="label">
                            AMOUNT OF PIECES
                        </th>
                        <th className="label">
                            % OF MAILED
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {(() => {
                        const line = ({label, qty, toolTip=undefined, className=undefined, darkBackground=false}) => (
                            <tr className={cx("line", className, {darkBackground})} key={label}>
                                <td className="label">
                                    {label}
                                    {toolTip && InformationBadge({
                                        height: 20,
                                        getTooltip: () => toolTip,
                                    })}
                                </td>
                                <td className="qty">
                                    {qty}
                                </td>
                                <td className="percentage">
                                    {Math.round((qty / totalRecords) * 100)}%
                                </td>
                            </tr>
                        );
                        return getRows(statusCounts, totalRecords).map((row) => line(row));
                    })()}
                </tbody>
            </table>
        </div>
    ),
);

const getRows = (statusCounts, totalRecords) => [
    {
        label: "On the Way",
        toolTip: "Mailing Pieces have finished production and are on their way to destination.",
        qty: totalRecords
    },
    {
        label: "Scanned by USPS",
        toolTip: "Mailing Pieces that have received their first scan from the USPS tracking systems.",
        qty: statusCounts?.scannedByUSPS ?? 0,
    },
    {
        label: "In Destination State",
        qty: statusCounts?.inDestinationState ?? 0,
    },
    {
        label: "Out for Delivery",
        qty: statusCounts?.outForDelivery ?? 0,
    },
    {
        label: "Redirected by USPS",
        className: "redirected",
        darkBackground: true,
        toolTip: "Indicates a mail piece was forwarded to a new address. Sometimes signifies a return to sender.",
        qty: statusCounts?.redirectedByUSPS ?? 0,
    },
    {
        label: "Marked for Return",
        darkBackground: true,
        toolTip: "USPS has determined the mail piece is undeliverable, and is returning it to the senders address.",
        qty: statusCounts?.markedForReturn ?? 0,
    },
];